import React from 'react';
import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { commonActions } from 'src/redux/commonRedux';

const NotFound: React.FC<Props> = ({ isLoading, setLoading }) => {
  return <h2>Page Not Found</h2>;
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
});

const mapDispatchToProps = {
  setLoading: commonActions.setLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotFound);
